import React from 'react';

import Card from 'ui/Card';
import Tooltip from 'ui/Tooltip';
import { Text } from 'ui/Typography';

type Props = {
  title: string;
  color: 'gray' | 'yellow';
  children?: React.ReactNode;
  tooltip?: string;
};

const ToolCard: React.FC<Props> = ({ title, color, children, tooltip }) => {
  return (
    <Card.Root
      backgroundColor={`${color}.50`}
      border="1px solid"
      borderColor={`${color}.300`}
      borderRadius={0}
      boxShadow="none"
    >
      <Card.Header pt={3} px={4} pb={0}>
        <Tooltip content={tooltip} positioning={{ placement: 'top' }} showArrow>
          <Text cursor={tooltip ? 'help' : 'inherit'} w="fit-content">
            {title}
          </Text>
        </Tooltip>
      </Card.Header>
      <Card.Body pt={0} px={4} pb={3}>
        {children}
      </Card.Body>
    </Card.Root>
  );
};

export default ToolCard;
